export default __webpack_public_path__ + "static/media/MUSISWAP (1) 2.0b40de71.svg";